// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__PT0sw","wrapper":"Hero_wrapper__vBa3F","content":"Hero_content__fvKtC","hero_kitty":"Hero_hero_kitty__XvAEp","btns":"Hero_btns__bDIwG"};